import { createContext, useContext } from "react";
import type { MaterialRequest } from "../types/material-request.types";

interface MaterialRequestOverviewContextType {
  materialRequest: MaterialRequest | null;
  refetch: () => Promise<void>;
}

const MaterialRequestOverviewContext =
  createContext<MaterialRequestOverviewContextType | null>(null);

export const useMaterialRequestOverview = () => {
  const context = useContext(MaterialRequestOverviewContext);
  if (!context) {
    throw new Error(
      "useMaterialRequestOverview must be used within provider",
    );
  }
  return context;
};

export default MaterialRequestOverviewContext;
